import React from "react";

type TimelineItem = {
  label: string;
  done: boolean;
  color?: string;
};

type TimelineProps = {
  items: TimelineItem[];
  deadline: string;
};

const Timeline: React.FC<TimelineProps> = ({ items, deadline }) => {
  const formattedDeadline = new Date(
    parseInt(deadline) * 1000,
  ).toLocaleString();

  return (
    <div className={"flex flex-col gap-4"}>
      <div className={"flex justify-center font-semibold mb-2 text-lg"}>
        <ul className="timeline">
          {items.map((item, index) => {
            const lineColor = item.color
              ? item.color
              : item.done
                ? "bg-primary"
                : "bg-gray-300";
            const iconColor = item.color
              ? item.color.replace("bg-", "text-")
              : item.done
                ? "text-primary"
                : "text-gray-400";

            return (
              <li key={index}>
                {index > 0 && <hr className={lineColor} />}

                <div
                  className={`${
                    index % 2 === 0 ? "timeline-start" : "timeline-end"
                  } timeline-box whitespace-normal break-words text-center`}
                >
                  {item.label.split("\n").map((line, i) => (
                    <React.Fragment key={i}>
                      {line}
                      {i < item.label.split("\n").length - 1 && <br />}
                    </React.Fragment>
                  ))}
                </div>

                <div className="timeline-middle">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                    className={`${iconColor} h-5 w-5`}
                  >
                    <path
                      fillRule="evenodd"
                      d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.857-9.809a.75.75 0 00-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 10-1.06 1.061l2.5 2.5a.75.75 0 001.137-.089l4-5.5z"
                      clipRule="evenodd"
                    />
                  </svg>
                </div>

                {index < items.length - 1 && <hr className={lineColor} />}
              </li>
            );
          })}
        </ul>
      </div>
      {deadline != "0" && (
        <div className="mt-5">
          Exchange deadline:{" "}
          <span className="font-bold">{formattedDeadline}</span>
        </div>
      )}
    </div>
  );
};

export default Timeline;
